var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1439 17.8829H4.67139",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2051 17.8839C15.2051 19.9257 15.886 20.6057 17.9269 20.6057C19.9678 20.6057 20.6487 19.9257 20.6487 17.8839C20.6487 15.8421 19.9678 15.1621 17.9269 15.1621C15.886 15.1621 15.2051 15.8421 15.2051 17.8839Z",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1768 7.39439H20.6484",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1154 7.39293C10.1154 5.35204 9.43448 4.67114 7.39358 4.67114C5.35179 4.67114 4.6709 5.35204 4.6709 7.39293C4.6709 9.43472 5.35179 10.1147 7.39358 10.1147C9.43448 10.1147 10.1154 9.43472 10.1154 7.39293Z",
    stroke: "#112950",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.04d28c80d9bddcfd9441eb7cc73db010.svg";
export { ForwardRef as ReactComponent };